import { IActionData, IDomainValue, IEntityDto, IEntityId } from 'models/common';
import { IOffice } from './office';
import { IServicesList } from './shopBookingTemplates';
import { IShopCard } from './shopcard';

export interface IServiceGroup extends IEntityDto, IEntityId {
	value: string;
	parentId?: IEntityId['id'] | null;
	serviceCategoryId?: IDomainValue['key'];
	officeId?: IOffice['id'];
	shopId?: IShopCard['id'];
	order: number;
	color?: IServiceGroupColor;
}

export type IServiceTreeServiceItem = Pick<
	IServicesList,
	| 'id'
	| 'variantParentId'
	| 'serviceGroupId'
	| 'name'
	| 'published'
	| 'price'
	| 'duration'
	| 'childrenBookingTemplates'
	| 'customData'
	| 'originalPrice'
>[];

export type IServiceGroupColor =
	| '#EA3546'
	| '#FF5722'
	| '#FF9800'
	| '#FFC107'
	| '#FFEB3B'
	| '#CDDC39'
	| '#8BC34A'
	| '#66BB6A'
	| '#26A69A'
	| '#00BCD4'
	| '#40C4FF'
	| '#448AFF'
	| '#536DFE'
	| '#7C4DFF'
	| '#C407E4'
	| '#FF4081';

export interface IServiceTree extends Pick<IServiceGroup, 'value' | 'id' | 'parentId' | 'order' | 'serviceCategoryId'> {
	uniq?: symbol;
	children: Array<IServiceTree | IServiceTreeServiceItem>;
	color?: IServiceGroupColor;
}

export const UNLINKED_KEY = 'unlinked';

export type IServiceGroupsForm = {
	serviceCategoryTree: IServiceTree[][]; // needs to be inside an object otherwise we cannot sort top level form values with array.move function
	numberOfTimesServiceGroupToggled: number; // for forcing FieldArray to update once service group shrink toggle is clicked
};

export interface IServiceGroups extends IActionData {
	serviceGroups: IServiceGroup[];
	fetchedByShop?: boolean;
	serviceGroupsById?: { [key: string]: IServiceGroup };
}

export interface IServiceGroupsAction {
	type: string;
	payload?: {
		serviceGroups?: IServiceGroup[];
		message?: any;
		fetchedByShop?: boolean;
		serviceGroupsById?: { [key: string]: IServiceGroup };
	};
}

export interface IUpdateServiceGroupsRequest {
	itemsToAdd: IServiceGroup[];
	itemsToUpdate: IServiceGroup[];
	itemsToRemove: string[]; // service group ID's
}
